import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

import EventDataSelector from '../../../../forms/EventDataSelector';
import EditEventDataField from '../../../../widgets/EditEventDataField';

export const handleEventDataChange = (newValue, index, eventData, handleUpdatedEventData) => {
  const eventDataList = sortBy(eventData, ['order', 'name']);
  eventDataList[index].value = newValue;
  handleUpdatedEventData(eventDataList);
};

export const EventDataFormComponent = ({
  handleUpdatedEventData,
  handleUpdatedEventDataInput,
  eventDataInputValue,
  allEventData,
  selectedEventData,
  helperText,
  isAdmin,
  showEventDataSelector,
}) => (
  <div>
    {
      showEventDataSelector && (
        <EventDataSelector
          onInputValueChange={handleUpdatedEventDataInput}
          inputValue={eventDataInputValue}
          availableItems={allEventData}
          selectedItem={selectedEventData}
          onChange={handleUpdatedEventData}
          itemToString={(eventData) => eventData.name}
          eventData={allEventData}
          helperText={helperText}
          isAdmin={isAdmin}
        />
      )
    }
    {
      sortBy(selectedEventData, ['order', 'name']).map((data, index) => (
        <EditEventDataField
          key={data.name}
          eventDataField={data}
          onChange={(value) => handleEventDataChange(value, index, selectedEventData, handleUpdatedEventData)}
        />
      ))
    }
  </div>
);

EventDataFormComponent.propTypes = {
  allEventData: PropTypes.array,
  selectedEventData: PropTypes.array,
  helperText: PropTypes.string,
  eventDataInputValue: PropTypes.string,
  handleUpdatedEventData: PropTypes.func,
  handleUpdatedEventDataInput: PropTypes.func,
  isAdmin: PropTypes.bool,
  showEventDataSelector: PropTypes.bool,
};

EventDataFormComponent.defaultProps = {
  allEventData: [],
  selectedEventData: [],
  eventDataInputValue: '',
  helperText: null,
  handleUpdatedEventData: () => {},
  handleUpdatedEventDataInput: () => {},
  isAdmin: false,
  showEventDataSelector: false,
};

export default EventDataFormComponent;
